import apiService from './api';

export interface Option {
  value: string;
  label: string;
}

class OptionsService {
  /**
   * Charger les véhicules
   */
  async getVehicules(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/camions/');
      return response.data.results?.map((v: any) => ({
        value: v.id.toString(),
        label: `${v.immatriculation} - ${v.marque} ${v.modele}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des véhicules:', error);
      return [];
    }
  }

  /**
   * Charger les remorques
   */
  async getRemorques(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/remorques/');
      return response.data.results?.map((r: any) => ({
        value: r.id.toString(),
        label: `${r.immatriculation} - ${r.marque} ${r.modele}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des remorques:', error);
      return [];
    }
  }

  /**
   * Charger les chauffeurs
   */
  async getChauffeurs(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/chauffeurs/');
      return response.data.results?.map((c: any) => ({
        value: c.id.toString(),
        label: `${c.prenom} ${c.nom} - ${c.telephone}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des chauffeurs:', error);
      return [];
    }
  }

  /**
   * Charger les convoyeurs
   */
  async getConvoyeurs(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/convoyeurs/');
      return response.data.results?.map((c: any) => ({
        value: c.id.toString(),
        label: `${c.nom} - ${c.telephone}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des convoyeurs:', error);
      return [];
    }
  }

  /**
   * Charger les clients
   */
  async getClients(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/clients/');
      return response.data.results?.map((c: any) => ({
        value: c.id.toString(),
        label: `${c.nom} - ${c.type}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des clients:', error);
      return [];
    }
  }

  /**
   * Charger les fournisseurs
   */
  async getFournisseurs(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/fournisseurs/');
      return response.data.results?.map((f: any) => ({
        value: f.id.toString(),
        label: `${f.nom} - ${f.cooperative}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des fournisseurs:', error);
      return [];
    }
  }

  /**
   * Charger les transporteurs
   */
  async getTransporteurs(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/transporteurs/');
      return response.data.results?.map((t: any) => ({
        value: t.id.toString(),
        label: `${t.nom} - ${t.type}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des transporteurs:', error);
      return [];
    }
  }

  /**
   * Charger les exportateurs
   */
  async getExportateurs(): Promise<Option[]> {
    try {
      const response = await apiService.get('/weighing/api/exportateurs/');
      return response.data.results?.map((e: any) => ({
        value: e.id.toString(),
        label: `${e.nom} - ${e.pays}`
      })) || [];
    } catch (error) {
      console.error('Erreur lors du chargement des exportateurs:', error);
      return [];
    }
  }

  /**
   * Charger toutes les options en parallèle
   */
  async getAllOptions() {
    try {
      const [
        vehicules,
        remorques,
        chauffeurs,
        convoyeurs,
        clients,
        fournisseurs,
        transporteurs,
        exportateurs
      ] = await Promise.all([
        this.getVehicules(),
        this.getRemorques(),
        this.getChauffeurs(),
        this.getConvoyeurs(),
        this.getClients(),
        this.getFournisseurs(),
        this.getTransporteurs(),
        this.getExportateurs()
      ]);

      return {
        vehicules,
        remorques,
        chauffeurs,
        convoyeurs,
        clients,
        fournisseurs,
        transporteurs,
        exportateurs
      };
    } catch (error) {
      console.error('Erreur lors du chargement des options:', error);
      return {
        vehicules: [],
        remorques: [],
        chauffeurs: [],
        convoyeurs: [],
        clients: [],
        fournisseurs: [],
        transporteurs: [],
        exportateurs: []
      };
    }
  }
}

export default new OptionsService();
